import React from 'react';
const TopAlert = ({ withdrawal, loginStatus, title }) => {
    if (withdrawal) {
        return (React.createElement("div", { className: "mb-4" },
            React.createElement("div", { className: "w-full bg-haikan-matching-red rounded-lg shadow-sm py-4 px-2 text-center text-gray-100" },
                "\u3053\u306E",
                title,
                "\u306F\u9000\u4F1A\u6E08\u307F\u3067\u3059")));
    }
    else if (!loginStatus) {
        return (React.createElement("div", { className: "mb-4" },
            React.createElement("div", { className: "w-full bg-haikan-matching-red rounded-lg shadow-sm py-4 px-2 text-center text-gray-100" },
                "\u3053\u306E",
                title,
                "\u306F\u7121\u52B9\u3067\u3059")));
    }
    else {
        return (React.createElement(React.Fragment, null));
    }
};
export default TopAlert;
